import React from "react";
import { Reveal } from "../hooks/useReveal";

const STEPS = [
  { n: "01", title: "Acquire XPTY", body: "Acquire XPTY through an officially supported market venue." },
  { n: "02", title: "Receive Tokens", body: "Receive XPTY in a compatible Solana wallet." },
  { n: "03", title: "1 Token = 10mg Platinum", body: "Each XPTY represents exactly ten milligrams of Platinum within the XPTY framework." },
  { n: "04", title: "Hold or Transfer", body: "Hold or transfer XPTY using compatible Solana infrastructure." },
  { n: "05", title: "Digital Utility", body: "XPTY is designed to interact with Xylapay’s expanding Real World Asset infrastructure." },
];

export default function HowItWorks() {
  return (
    <section className="w-full py-[80px] lg:py-[140px] bg-[#0D0E0E] border-y hairline">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-[64px]">
        <Reveal>
          <span className="micro-label">How It Works</span>
          <h2 className="mt-5 max-w-[640px] text-[32px] sm:text-[42px] lg:text-[52px] font-medium tracking-[-0.02em] leading-[1.05] text-[#F1F2EF]">
            From Platinum to programmable settlement.
          </h2>
        </Reveal>

        <div className="mt-16 border-t hairline">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={0.04 * i}>
              <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-baseline py-8 border-b hairline group">
                <div className="md:col-span-2 text-[13px] tracking-[0.18em] text-[#6D726F] tabular-nums">
                  {s.n}
                </div>
                <div className="md:col-span-4">
                  <h3 className="text-[20px] lg:text-[24px] font-medium text-[#F1F2EF] group-hover:text-white transition-colors duration-300">
                    {s.title}
                  </h3>
                </div>
                <div className="md:col-span-6">
                  <p className="text-[15px] leading-[1.6] text-[#A0A5A2] max-w-[520px]">
                    {s.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
